export const textPositionTokens = {
	left: 'start',
	center: 'center',
	right: 'end',
};
